import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MensajeModel } from '../Modelo/Mensajes.model';
import { MensajesService } from '../Servicios/mensajes.service';
import { String } from '../utilidades/Extensions/string-extensions';
import { AppSettingsModel } from 'src/app/Modelo/AppSettings.Model';
import { SettingsService } from 'src/app/servicios/settings.service';


@Component({
	selector: 'app-contacto',
	templateUrl: './contacto.component.html',
	styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent {
	public openModalPhone = false;
	private _formModel: MensajeModel;
	appSettings: AppSettingsModel;
	
	@ViewChild('phone') menu: ElementRef;
	@ViewChild('phone2') menu2: ElementRef;

	@HostListener('document:mousedown', ['$event']) onGlobalClick(event): void {
		if (event.target !== this.menu?.nativeElement && event.target !== this.menu2?.nativeElement) {
			this.openModalPhone = false;
		}
  	}

	constructor(private messageService: MensajesService, private _appSettingsService: SettingsService) { }

	ngOnInit(): void {
		this._formModel = new MensajeModel();
		this._appSettingsService.get().then((appSettings: AppSettingsModel) => this.appSettings = appSettings );
	}

	get formModel(): MensajeModel {
		return this._formModel;
	}

	get captchaWasResolved(): boolean {
		return !String.isNullOrWhiteSpace(this.formModel.Captcha)
	}

	get reCaptchaKeyIsReady(): boolean {
		return !String.isNullOrWhiteSpace(this.appSettings?.reCaptcha?.siteKey);
	}

	public onCaptchaResolved(captchaResponse: string): void {
        this.formModel.Captcha = captchaResponse;
		console.log(captchaResponse);
	}

	public onSubmit(form: NgForm): void {
		if (!form.dirty || form.invalid)
			return;

		this.messageService.Nuevo(this.formModel, 'Contacto/Nuevo').toPromise().then(response => {
			console.log(response);
		}).catch(error => {
			console.log(error);
		});
	}

}